import { DATE_FORMATS, DEFAULT_LOCALE, formatMoney, type Locale } from "@bizy/core";
import { format as formatDateFns, formatDistanceToNowStrict, parseISO } from "date-fns";

export { formatMoney, formatAmount, roundMoney } from "@bizy/core";

const parse = (value: string | Date): Date => (value instanceof Date ? value : parseISO(value));

export const formatDate = (value: string | Date | null | undefined, pattern: string = DATE_FORMATS.date): string =>
  value ? formatDateFns(parse(value), pattern) : "—";

export const formatDateTime = (value: string | Date | null | undefined): string =>
  formatDate(value, DATE_FORMATS.dateTime);

export const formatRelative = (value: string | Date | null | undefined): string =>
  value ? `${formatDistanceToNowStrict(parse(value))} ago` : "—";

export const formatQuantity = (value: number, unit?: string | null): string =>
  unit ? `${value.toLocaleString()} ${unit}` : value.toLocaleString();

export const formatPercent = (value: number): string => `${value.toFixed(value % 1 === 0 ? 0 : 1)}%`;

export const formatCurrency = (value: number, currency: string, locale: Locale = DEFAULT_LOCALE): string =>
  formatMoney(value, currency, locale);

/** `2026-10-18T09:00:00Z` → value for `<input type="datetime-local">`. */
export const toDateTimeLocalValue = (value: string | null | undefined): string => {
  if (!value) return "";
  const date = parse(value);
  const offset = date.getTimezoneOffset() * 60_000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
};

export const fromDateTimeLocalValue = (value: string): string | null =>
  value.length === 0 ? null : new Date(value).toISOString();
